<template>
  <div class="p-2">
    <LiveAuction v-if="store.live_auction"></LiveAuction>
  </div>
</template>
<script setup>
import LiveAuction from "../bidder/liveauction/LiveAuction";
import { useStore } from "../../store/index";
const store = useStore();
</script>
